import { api } from "@/api";
import { ChatWidgetTypingRequest } from "@/types";

/**
 * Notify the backend that the customer is typing during a live-chat handoff.
 *
 * Fire-and-forget presence ping; the backend records an ephemeral timestamp the
 * operator inbox reads. Callers should throttle this (see chatSession) so a burst
 * of keystrokes produces at most one request per interval.
 *
 * @param siteId - TOMIS site slug
 * @param args - user/conversation ids
 */
export async function sendCustomerTyping(
  siteId: string,
  args: { userId: string; conversationId: string },
): Promise<{ data?: { success: boolean }; error?: string }> {
  const body: ChatWidgetTypingRequest = {
    user_id: args.userId,
    conversation_id: args.conversationId,
  };

  return api.post<{ success: boolean }>(`/${siteId}/chat-widget/typing/`, body);
}
